/*
 * Stripe Checkout for Shopify – theme script
 * Upload to: Online Store → Themes → Edit code → Assets → "stripe-checkout.js"
 * Config is set in theme.liquid (see snippet-theme-liquid.html).
 *
 * - Intercepts "Buy it now" and "Checkout" buttons and sends the buyer to Stripe Checkout.
 * - If anything fails (server down, slow, error), it falls back to the normal Shopify checkout.
 * - On the thank-you page it clears the cart, shows the order number and fires the Meta pixel
 *   Purchase with the same event id as the server (deduplication).
 */
(function () {
  "use strict";
  var cfg = window.STRIPE_CHECKOUT || {};
  var API = (cfg.api || "").replace(/\/$/, "");
  if (!API) return;

  var THANK_YOU_PATH = cfg.thankYouPath || "/pages/thank-you";
  var LOADING_TEXT = cfg.loadingText || "…";
  var FALLBACK_MS = cfg.fallbackMs || 6000;
  var PERCENT = typeof cfg.percent === "number" ? cfg.percent : 100; // % of visitors that get Stripe

  /* ---------- helpers ---------- */
  function getCookie(name) {
    var m = document.cookie.match(new RegExp("(?:^|; )" + name + "=([^;]*)"));
    return m ? decodeURIComponent(m[1]) : "";
  }
  function getFbc() {
    var c = getCookie("_fbc");
    if (c) return c;
    var id = new URLSearchParams(location.search).get("fbclid");
    if (!id) return "";
    c = "fb.1." + Date.now() + "." + id;
    document.cookie = "_fbc=" + c + ";path=/;max-age=7776000;SameSite=Lax";
    return c;
  }
  // Marketing consent from Shopify's cookie banner (Customer Privacy API).
  // true = allowed, false = refused, null = unknown (no banner / API not loaded)
  function marketingConsent() {
    try {
      var cp = window.Shopify && window.Shopify.customerPrivacy;
      if (cp && typeof cp.marketingAllowed === "function") return !!cp.marketingAllowed();
    } catch (e) {}
    return null;
  }
  // Create the Meta browser id (_fbp) if Meta's own pixel did not set it on this domain
  function getFbp() {
    var c = getCookie("_fbp");
    if (c || marketingConsent() === false) return c;
    c = "fb.1." + Date.now() + "." + Math.floor(1e9 + Math.random() * 9e9);
    document.cookie = "_fbp=" + c + ";path=/;max-age=7776000;SameSite=Lax";
    return c;
  }
  if (marketingConsent() !== false) getFbc(); // save fbclid on landing

  // Sticky traffic split (useful for rolling out to e.g. 20% first)
  function inStripeGroup() {
    if (/[?&]stripe=off/.test(location.search)) return false;
    if (/[?&]stripe=on/.test(location.search)) return true;
    if (PERCENT >= 100) return true;
    try {
      var g = localStorage.getItem("stripe_group");
      if (!g) {
        g = Math.random() * 100 < PERCENT ? "on" : "off";
        localStorage.setItem("stripe_group", g);
      }
      return g === "on";
    } catch (e) {
      return false;
    }
  }

  /* ---------- thank-you page ---------- */
  if (location.pathname.replace(/\/$/, "") === THANK_YOU_PATH) {
    var sid = new URLSearchParams(location.search).get("sid");
    if (sid) {
      fetch("/cart/clear.js", { method: "POST" }).catch(function () {});
      // The Shopify order is created by the webhook a few seconds after payment:
      // poll until it exists, then open Shopify's own order status page (same look as Shopify checkout).
      var REDIRECT = cfg.orderStatusRedirect !== false;
      var MAX_TRIES = 40; // ~60 seconds: TWINT / slow webhooks can take a while
      var tries = 0;
      var pixelSent = false;
      var again = function () {
        if (tries < MAX_TRIES) setTimeout(poll, tries < 10 ? 1000 : 2000);
      };
      var poll = function () {
        tries++;
        fetch(API + "/api/session?sid=" + encodeURIComponent(sid), { cache: "no-store" })
          .then(function (r) { return r.json(); })
          .then(function (d) {
            if (!d || !d.paid) return again(); // payment not confirmed yet -> keep waiting
            if (!pixelSent) {
              pixelSent = true;
              var key = "stripe_px_" + sid;
              var already = false;
              try { already = !!sessionStorage.getItem(key); sessionStorage.setItem(key, "1"); } catch (e) {}
              if (!already && typeof window.fbq === "function") {
                window.fbq("track", "Purchase", { value: d.value, currency: d.currency }, { eventID: sid });
              }
            }
            var el = document.getElementById("stripe-order-info");
            if (el && d.order_name) el.textContent = d.order_name;
            if (REDIRECT && d.status_url) {
              setTimeout(function () { location.replace(d.status_url); }, 400); // let the pixel send
              return;
            }
            if (!d.order_name || (REDIRECT && !d.status_url)) again();
          })
          .catch(again);
      };
      poll();
    }
    return;
  }

  if (!inStripeGroup()) return;

  /* ---------- speed: open connections early + warm up the server ---------- */
  // Preconnect to our API and the Stripe checkout page, so the click doesn't wait for DNS/TLS.
  // cfg.checkoutDomain = your Stripe custom domain (e.g. "https://checkout.goldmomentshop.com").
  [API, cfg.checkoutDomain || "https://checkout.stripe.com", "https://js.stripe.com"].forEach(function (href) {
    try {
      var l = document.createElement("link");
      l.rel = "preconnect";
      l.href = href;
      l.crossOrigin = "anonymous";
      document.head.appendChild(l);
    } catch (e) {}
  });
  // Wake the server once per visit (avoids a slow "cold start" on the first Zur Kasse click)
  (function warmUp() {
    try {
      var last = Number(sessionStorage.getItem("stripe_warm") || 0);
      if (Date.now() - last < 4 * 60 * 1000) return;
      sessionStorage.setItem("stripe_warm", String(Date.now()));
    } catch (e) {}
    var go = function () { fetch(API + "/api/ping", { mode: "cors" }).catch(function () {}); };
    if ("requestIdleCallback" in window) window.requestIdleCallback(go, { timeout: 3000 });
    else setTimeout(go, 1500);
  })();

  /* ---------- checkout ---------- */
  var busy = false;

  function setLoading(btn) {
    if (!btn) return;
    btn.setAttribute("data-original-text", btn.textContent || "");
    btn.setAttribute("aria-busy", "true");
    if ("disabled" in btn) btn.disabled = true;
    btn.textContent = LOADING_TEXT;
  }
  function resetLoading(btn) {
    if (!btn) return;
    btn.removeAttribute("aria-busy");
    if ("disabled" in btn) btn.disabled = false;
    var t = btn.getAttribute("data-original-text");
    if (t !== null) btn.textContent = t;
  }

  function goToShopifyCheckout(items) {
    // Fallback: normal Shopify checkout
    if (items) {
      // Buy-now item: use a cart permalink so only this item is checked out
      location.href = "/cart/" + items.map(function (i) { return i.variant_id + ":" + i.quantity; }).join(",");
    } else {
      location.href = "/checkout";
    }
  }

  function startStripe(btn, buyNowItems) {
    if (busy) return;
    busy = true;
    setLoading(btn);

    var done = false;
    var fallback = setTimeout(function () {
      if (done) return;
      done = true;
      goToShopifyCheckout(buyNowItems);
    }, FALLBACK_MS);

    var itemsPromise = buyNowItems
      ? Promise.resolve(buyNowItems)
      : fetch("/cart.js", { headers: { Accept: "application/json" } })
          .then(function (r) { return r.json(); })
          .then(function (cart) {
            return (cart.items || []).map(function (i) {
              return { variant_id: i.variant_id, quantity: i.quantity };
            });
          });

    itemsPromise
      .then(function (items) {
        if (!items.length) throw new Error("empty cart");
        return fetch(API + "/api/checkout", {
          method: "POST",
          headers: { "Content-Type": "application/json" },
          body: JSON.stringify((function () {
            var consent = marketingConsent();
            return {
              items: items,
              country: (window.Shopify && window.Shopify.country) || "",
              marketing_consent: consent,
              fbp: consent === false ? "" : getFbp(),
              fbc: consent === false ? "" : getFbc(),
              page_url: location.href,
            };
          })()),
        });
      })
      .then(function (r) { return r.json(); })
      .then(function (d) {
        if (done) return;
        if (!d || !d.url) throw new Error((d && d.error) || "no checkout url");
        done = true;
        clearTimeout(fallback);
        location.href = d.url;
      })
      .catch(function (err) {
        console.warn("[stripe-checkout] falling back to Shopify checkout:", err);
        if (done) return;
        done = true;
        clearTimeout(fallback);
        busy = false;
        resetLoading(btn);
        goToShopifyCheckout(buyNowItems);
      });
  }

  // "Buy it now" -> only the selected variant, not the whole cart (same as Shopify)
  function buyNowItemsFrom(el) {
    var form =
      el.closest('form[action*="/cart/add"]') ||
      (el.closest("product-form, .product-form, [data-product-form], .product__info-wrapper, .product") || document)
        .querySelector('form[action*="/cart/add"]');
    if (!form) return null;
    var fd = new FormData(form);
    var id = fd.get("id");
    var qty = parseInt(fd.get("quantity") || "1", 10) || 1;
    if (!id) return null;
    return [{ variant_id: id, quantity: qty }];
  }

  var BUY_NOW_SELECTOR =
    ".shopify-payment-button, shopify-buy-it-now-button, [data-shopify='payment-button'], [data-stripe-buy-now]";
  var CHECKOUT_SELECTOR = [
    "[name='checkout']",
    "#CartDrawer-Checkout",
    "[data-stripe-checkout]",
    "a[href='/checkout']",
    "a[href='/checkout/']",
    "a[href$='/checkout']",
  ].join(",");

  // Find the clicked element that matches `selector`, also inside shadow DOM
  // (cart apps like "Section Store" render their checkout button in a shadow root).
  function matchInPath(e, selector) {
    var path = typeof e.composedPath === "function" ? e.composedPath() : [];
    for (var i = 0; i < path.length; i++) {
      var el = path[i];
      if (el && el.nodeType === 1 && el.matches && el.matches(selector)) return el;
    }
    var t = e.target;
    return t && t.closest ? t.closest(selector) : null;
  }

  document.addEventListener(
    "click",
    function (e) {
      var target = e.target;
      if (!target) return;

      var buyNow = matchInPath(e, BUY_NOW_SELECTOR);
      if (buyNow) {
        var items = buyNowItemsFrom(buyNow);
        if (!items) return; // let Shopify handle it
        e.preventDefault();
        e.stopImmediatePropagation();
        var btn = buyNow.querySelector("button") || buyNow;
        startStripe(btn, items);
        return;
      }

      var checkout = matchInPath(e, CHECKOUT_SELECTOR);
      if (checkout) {
        e.preventDefault();
        e.stopImmediatePropagation();
        startStripe(checkout, null);
      }
    },
    true // capture phase: runs before the theme's own handlers
  );

  // Cart form submitted with Enter / submit button
  document.addEventListener(
    "submit",
    function (e) {
      var form = e.target;
      if (!form || !form.getAttribute) return;
      var action = form.getAttribute("action") || "";
      var submitter = e.submitter;
      var isCheckout =
        /\/checkout\/?$/.test(action) ||
        (/\/cart\/?$/.test(action) && submitter && submitter.getAttribute("name") === "checkout");
      if (!isCheckout) return;
      e.preventDefault();
      e.stopImmediatePropagation();
      startStripe(submitter || null, null);
    },
    true
  );

  // If the user comes back with the browser "back" button, re-enable buttons
  window.addEventListener("pageshow", function (e) {
    if (e.persisted) {
      busy = false;
      document.querySelectorAll("[aria-busy='true']").forEach(resetLoading);
    }
  });
})();